export enum QuizSportType {
	Soccer = 1,
	Basketball = 2,
	Tennis = 5,
}

export const quizSupportedSports = [QuizSportType.Basketball, QuizSportType.Soccer, QuizSportType.Tennis];
